import {Component, OnInit} from '@angular/core';
import {filter, map, takeUntil} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {FilterModel} from '@shared/models/filter.models';
import {Observable, Subject} from 'rxjs';
import {IDashboardState} from '../store/reducer/dashboard-reducer';
import {getDashboardState, getTabId, getDashBoardCurrentState} from '../store/selector/dashboard-selector';
import {Location} from '@angular/common';
@Component({
    standalone: false,
    selector: 'particle-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styleUrls: ['./dashboard-filter.component.scss']
})
export class DashboardFilterComponent implements OnInit {
  filter$: Observable<FilterModel>;
  filter: FilterModel;
  dashboardState: IDashboardState;
  filterKey = 'dashboardInputFilter';
  unsubscribe$ = new Subject<void>();
  previousUrl
  constructor(private store: Store<IQueryState>,
              private dashboardStore: Store<IDashboardState>,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }

  ngOnInit() {
    this.dashboardStore.pipe(select(getDashBoardCurrentState), takeUntil(this.unsubscribe$)).subscribe((state: IDashboardState) => {
      this.dashboardState = state;
    });
  }

  navigateToPreviousRoute() {
    this.location.back();
    /*this.router.navigate(['./dashboard', this.dashboardState.tabId], {
      relativeTo: this.activateRoute.parent,
      queryParams: this.dashboardState.queryParameters
    });*/
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
